








































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import BaseModalWindow from "@/app/shared/components/base/BaseModalWindow.vue";
import BaseSearchInput from "@/app/shared/components/base/BaseSearchInput.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import BaseAnimation from "@/app/shared/components/base/BaseAnimation.vue";
import BaseMediaButton from "@/app/modules/work/components/shared/BaseMediaButton.vue";
import { $eventsBus } from "@/main";
import { MoveableOverlayText } from "../../models/classes/moveable-overlays/MoveableOverlayText";
import { MoveableOverlayShape } from "../../models/classes/moveable-overlays/MoveableOverlayShape";
import { MoveableOverlayImage } from "../../models/classes/moveable-overlays/MoveableOverlayImage";
import { MoveableOverlayVideo } from "../../models/classes/moveable-overlays/MoveableOverlayVideo";
import { MoveableOverlayStockImage } from "../../models/classes/moveable-overlays/MoveableOverlayStockImage";
import { MoveableOverlayEmojipediaImage } from "../../models/classes/moveable-overlays/MoveableOverlayEmojipediaImage";
import { MoveableOverlayAnimation } from "../../models/classes/moveable-overlays/MoveableOverlayAnimation";
import { LottieTemplates } from "@/app/modules/work/models/templates/overlays/LottieTemplates";
import { TextTemplates } from "@/app/modules/work/models/templates/overlays/TextTemplates";
import _ from "lodash";
import { MoveableOverlayStockVideo } from "../../models/classes/moveable-overlays/MoveableOverlayStockVideo";

export default Vue.extend({
  name: "OverlaysLibraryWindow",
  components: {
    BaseModalWindow,
    BaseSearchInput,
    BaseButton,
    BaseAnimation,
    BaseMediaButton,
  },
  data: function () {
    return {
      filteredImageFiles: [],
      filteredVideoFiles: [],
      stockRoasUpFiles: [],
      stockPixabayFiles: [],
      stockPixabayVideoFiles: [],
      emojipediaFiles: [],
      tab: "image",

      selectedFile: {
        file: null,
        type: null,
      },
      currentOverlay: null,
      isEditMode: false,
      selectedNewOverlays: [],

      searchValue: "",

      stockRoasUpLastSearchValue: "",
      stockRoasUpCurrentSearchPage: 1,
      stockRoasUpLimitSearchPage: 1,
      isStockRoasUpWaitSearch: false,

      stockPixabayLastSearchValue: "",
      stockPixabayCurrentSearchPage: 1,
      stockPixabayLimitSearchPage: 1,
      isStockPixabayWaitSearch: false,

      stockPixabayVideoLastSearchValue: "",
      stockPixabayVideoCurrentSearchPage: 1,
      stockPixabayVideoLimitSearchPage: 1,
      isStockPixabayVideoWaitSearch: false,

      emojipediaLastSearchValue: "",
      emojipediaCurrentSearchStart: 0,
      emojipediaLimitSearchCount: 1,
      isEmojipediaWaitSearch: false,

      conformityTabType: {
        image: ["image"],
        "image-recent": ["image"],
        "image-default": ["image"],
        "image-uploaded": ["image"],
        video: ["video"],
        text: ["text"],
        elements: [
          "shape",
          "animation-shape",
          "animation-timer",
          "animation-button",
          "animation-age-rating",
        ],
        "elements-animation-shape": ["animation-shape"],
        "elements-animation-timer": ["animation-timer"],
        "elements-animation-button": ["animation-button"],
        "elements-animation-age-rating": ["animation-age-rating"],
        emojipedia: ["emojipedia"],
        stocks: ["stock", "pixabay", "pixabay-video"],
        "stock-roasup": ["stock"],
        "stock-pixabay": ["pixabay"],
        "stock-pixabay-video": ["pixabay-video"],
      },
      selectedTextTemplate: 0,
      filteredShapes: [],
      tagHints: [
        "Flag",
        "Face",
        "Car",
        "Game",
        "Cat",
        "Brain",
        "Fire",
        "Star",
        "Heart",
      ],
    };
  },
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    userStockAccess: function () {
      return this.$store.state.userInfo.stockAccess;
    },
    imageFiles: function () {
      return this.$store.getters.getImagesOverlaysLibrary;
    },
    recentImageFiles: function () {
      return this.isLoading ? [] : this.$store.getters.getRecentImages;
    },
    textStyleTemplates: function () {
      return TextTemplates.textStyleTemplates;
    },
    filteredRecentImageFiles: function () {
      return this.isLoading
        ? []
        : this.$store.getters.getRecentImages
            .filter(
              (f) =>
                f?.name &&
                f.name
                  .toString()
                  .toLowerCase()
                  .split(".")
                  .slice(0, -1)
                  .join(".")
                  .indexOf(this.searchValue.toLowerCase()) !== -1
            )
            .slice(0, 18);
    },
    animatedShapes: function () {
      return LottieTemplates.animatedShapes;
    },
    animatedTimers: function () {
      return LottieTemplates.animatedTimers;
    },
    animatedButtons: function () {
      return LottieTemplates.animatedButtons;
    },
    animatedAgeRatings: function () {
      return LottieTemplates.animatedAgeRatings;
    },
    filteredAnimatedShapes: function () {
      return this.animatedShapes.filter(
        (f) =>
          f?.name &&
          f.name
            .toString()
            .toLowerCase()
            .indexOf(this.searchValue.toLowerCase()) !== -1
      );
    },
    filteredAnimatedTimers: function () {
      return this.animatedTimers.filter(
        (f) =>
          f?.name &&
          f.name
            .toString()
            .toLowerCase()
            .indexOf(this.searchValue.toLowerCase()) !== -1
      );
    },
    filteredAnimatedButtons: function () {
      return this.animatedButtons.filter(
        (f) =>
          f?.name &&
          f.name
            .toString()
            .toLowerCase()
            .indexOf(this.searchValue.toLowerCase()) !== -1
      );
    },
    filteredAnimatedAgeRatings: function () {
      return this.animatedAgeRatings.filter(
        (f) =>
          f?.name &&
          f.name
            .toString()
            .toLowerCase()
            .indexOf(this.searchValue.toLowerCase()) !== -1
      );
    },
    videoFiles: function () {
      return this.$store.getters.getVideosOverlaysLibrary;
    },
    shapes: function () {
      return this.$store.getters.getShapesOverlaysLibrary;
    },
  },
  created() {
    $eventsBus.$on("editOverlay", (overlay) => {
      this.currentOverlay = overlay;
      this.isEditMode = true;
      if (overlay?.file) {
        this.selectedFile.file = overlay.file;
        this.selectedFile.type = overlay.type;
      }

      const file = this.currentOverlay.file;

    // Возможно нужно фиксить, как и в EndCardLibraryWindow
      this.tab = Object.keys(this.conformityTabType).find((key) =>
        this.conformityTabType[key].includes(overlay.type)
      );
    });
  },
  mounted() {
    this.search(this.searchValue, false);
    $eventsBus.$emit("muteMainContent", true);
  },
  watch: {
    tab: function () {
      this.search(this.searchValue);
      if (this.tab === "stocks") {
        const imagesStockRoasUp = this.$refs.imagesStockRoasUp;
        if (imagesStockRoasUp.onscroll) {
          return;
        }
        imagesStockRoasUp.onscroll = (e) => {
          if (
            imagesStockRoasUp.scrollTop + imagesStockRoasUp.clientHeight >=
            imagesStockRoasUp.scrollHeight
          ) {
            this.searchMoreStockRoasUp();
          }
        };
        const imagesStockPixabay = this.$refs.imagesStockPixabay;
        if (imagesStockPixabay.onscroll) {
          return;
        }
        imagesStockPixabay.onscroll = (e) => {
          if (
            imagesStockPixabay.scrollTop + imagesStockPixabay.clientHeight >=
            imagesStockPixabay.scrollHeight
          ) {
            this.searchMoreStockPixabay();
          }
        };
        const videosStockPixabay = this.$refs.videosStockPixabay;
        if (videosStockPixabay.onscroll) {
          return;
        }
        videosStockPixabay.onscroll = (e) => {
          if (
            videosStockPixabay.scrollTop + videosStockPixabay.clientHeight >=
            videosStockPixabay.scrollHeight
          ) {
            this.searchMoreStockPixabayVideo();
          }
        };
      } else if (this.tab === "emojipedia") {
        const emojipediaBlock = this.$refs.emojipediaBlock;
        if (emojipediaBlock.onscroll) {
          return;
        }
        emojipediaBlock.onscroll = (e) => {
          if (
            emojipediaBlock.scrollTop + emojipediaBlock.clientHeight >=
            emojipediaBlock.scrollHeight
          ) {
            this.searchMoreEmojipedia();
          }
        };
      }
    },
    isLoading: function () {
      if (!this.isLoading) {
        this.searchInLibrary();
      }
    },
  },
  methods: {
    getLineBackground(template) {
      let converted = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
        template.box.color
      );
      let rgb = converted
        ? {
            r: parseInt(converted[1], 16),
            g: parseInt(converted[2], 16),
            b: parseInt(converted[3], 16),
          }
        : { r: 0, g: 0, b: 0 };
      return (
        "rgba(" +
        rgb.r +
        ", " +
        rgb.g +
        ", " +
        rgb.b +
        ", " +
        template.opacity +
        ")"
      );
    },
    searchInLibrary() {
      if (this.searchValue === "") {
        this.filteredImageFiles = this.imageFiles;
        this.filteredVideoFiles = this.videoFiles;
        this.filteredShapes = this.shapes;
      } else {
        this.filteredImageFiles = this.imageFiles.filter(
          (f) =>
            f?.name &&
            f.name
              .toString()
              .toLowerCase()
              .split(".")
              .slice(0, -1)
              .join(".")
              .indexOf(this.searchValue.toLowerCase()) !== -1
        );
        this.filteredVideoFiles = this.videoFiles.filter(
          (f) =>
            f?.name &&
            f.name
              .toString()
              .toLowerCase()
              .split(".")
              .slice(0, -1)
              .join(".")
              .indexOf(this.searchValue.toLowerCase()) !== -1
        );
        this.filteredShapes = this.shapes.filter(
          (f) =>
            f?.name &&
            f.name
              .toString()
              .toLowerCase()
              .indexOf(this.searchValue.toLowerCase()) !== -1
        );
      }
    },
    search(value, isUpdate = true) {
      this.searchValue = value;
      this.searchInLibrary();

      if (
        !isUpdate ||
        (this.conformityTabType[this.tab].includes("stock") &&
          this.stockRoasUpLastSearchValue !== value)
      ) {
        this.stockRoasUpFiles = [];
        this.stockRoasUpCurrentSearchPage = 1;
        this.stockRoasUpLimitSearchPage = 1;
        this.isStockRoasUpWaitSearch = true;
        this.stockRoasUpLastSearchValue = value;
        this.requestStockRoasUpList();
      }
      if (
        !isUpdate ||
        (this.conformityTabType[this.tab].includes("pixabay") &&
          this.stockPixabayLastSearchValue !== value)
      ) {
        this.stockPixabayFiles = [];
        this.stockPixabayCurrentSearchPage = 1;
        this.stockPixabayLimitSearchPage = 1;
        this.isStockPixabayWaitSearch = true;
        this.stockPixabayLastSearchValue = value;
        this.requestStockPixabayList();
      }
      if (
        !isUpdate ||
        (this.conformityTabType[this.tab].includes("pixabay-video") &&
          this.stockPixabayVideoLastSearchValue !== value)
      ) {
        this.stockPixabayVideoFiles = [];
        this.stockPixabayVideoCurrentSearchPage = 1;
        this.stockPixabayVideoLimitSearchPage = 1;
        this.isStockPixabayVideoWaitSearch = true;
        this.stockPixabayVideoLastSearchValue = value;
        this.requestStockPixabayVideoList();
      }
      if (
        !isUpdate ||
        (this.conformityTabType[this.tab].includes("emojipedia") &&
          this.emojipediaLastSearchValue !== value)
      ) {
        this.emojipediaFiles = [];
        this.emojipediaCurrentSearchStart = 0;
        this.emojipediaLimitSearchCount = 1;
        this.isEmojipediaWaitSearch = true;
        this.emojipediaLastSearchValue = value;
        this.requestEmojipediaList();
      }
    },
    searchMoreStockRoasUp() {
      console.log("try search more stock");
      if (
        /*
        this.searchValue === "" || */
        this.stockRoasUpCurrentSearchPage === this.stockRoasUpLimitSearchPage ||
        this.isStockRoasUpWaitSearch
      ) {
        return;
      }
      this.isStockRoasUpWaitSearch = true;
      this.requestStockRoasUpList();
    },
    requestStockRoasUpList() {
      if (!this.userStockAccess) {
        this.isStockRoasUpWaitSearch = false;
        return;
      }
      this.axios
        .post(
          "/utils/storyblocksList",
          {
            tag: this.searchValue,
            page: this.stockRoasUpCurrentSearchPage,
            mode: "images",
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (this.searchValue !== JSON.parse(response.config.data).tag) {
            return;
          }
          this.stockRoasUpLimitSearchPage = response.data.limit;
          this.stockRoasUpCurrentSearchPage =
            this.stockRoasUpCurrentSearchPage ===
            this.stockRoasUpLimitSearchPage
              ? this.stockRoasUpLimitSearchPage
              : this.stockRoasUpCurrentSearchPage + 1;
          response.data.list.forEach((file) => {
            if (!!this.stockRoasUpFiles.find((f) => f.id === file.id)) {
              return;
            }
            this.stockRoasUpFiles.push({
              ...file,
              systemMethod: "stock",
              isPlug: true,
            });
          });
          this.isStockRoasUpWaitSearch = false;
        });
    },
    searchMoreStockPixabay() {
      console.log("try search more stock");
      if (
        /*
        this.searchValue === "" || */
        this.stockPixabayCurrentSearchPage ===
          this.stockPixabayLimitSearchPage ||
        this.isStockPixabayWaitSearch
      ) {
        return;
      }
      this.isStockPixabayWaitSearch = true;
      this.requestStockPixabayList();
    },
    requestStockPixabayList() {
      this.axios
        .post(
          "/overlays/pixabayList",
          {
            search: this.searchValue,
            page: this.stockPixabayCurrentSearchPage,
            sessionId: this.$store.state.userInfo.sessionId,
            type: "image",
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (this.searchValue !== JSON.parse(response.config.data).search) {
            return;
          }
          this.stockPixabayLimitSearchPage = response.data.limit;
          this.stockPixabayCurrentSearchPage =
            this.stockPixabayCurrentSearchPage ===
            this.stockPixabayLimitSearchPage
              ? this.stockPixabayLimitSearchPage
              : this.stockPixabayCurrentSearchPage + 1;
          response.data.items.forEach((file) => {
            if (!!this.stockPixabayFiles.find((f) => f.id === file.id)) {
              return;
            }
            this.stockPixabayFiles.push({
              ...file,
              systemMethod: "pixabay",
              isPlug: true,
            });
          });
          this.isStockPixabayWaitSearch = false;
        });
    },
    searchMoreStockPixabayVideo() {
      console.log("try search more stock");
      if (
        /*
        this.searchValue === "" || */
        this.stockPixabayVideoCurrentSearchPage ===
          this.stockPixabayVideoLimitSearchPage ||
        this.isStockPixabayVideoWaitSearch
      ) {
        return;
      }
      this.isStockPixabayVideoWaitSearch = true;
      this.requestStockPixabayVideoList();
    },
    requestStockPixabayVideoList() {
      this.axios
        .post(
          "/overlays/pixabayList",
          {
            search: this.searchValue,
            page: this.stockPixabayVideoCurrentSearchPage,
            sessionId: this.$store.state.userInfo.sessionId,
            type: "video",
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (this.searchValue !== JSON.parse(response.config.data).search) {
            return;
          }
          this.stockPixabayVideoLimitSearchPage = response.data.limit;
          this.stockPixabayVideoCurrentSearchPage =
            this.stockPixabayVideoCurrentSearchPage ===
            this.stockPixabayVideoLimitSearchPage
              ? this.stockPixabayVideoLimitSearchPage
              : this.stockPixabayVideoCurrentSearchPage + 1;
          response.data.items.forEach((file) => {
            if (!!this.stockPixabayVideoFiles.find((f) => f.id === file.id)) {
              return;
            }
            this.stockPixabayVideoFiles.push({
              ...file,
              systemMethod: "pixabay-video",
              isPlug: true,
            });
          });
          this.isStockPixabayVideoWaitSearch = false;
        });
    },
    searchMoreEmojipedia() {
      console.log("try search more emojipedia");
      if (
        /*
        this.searchValue === "" || */
        this.emojipediaCurrentSearchStart >= this.emojipediaLimitSearchCount ||
        this.isEmojipediaWaitSearch
      ) {
        return;
      }
      this.isEmojipediaWaitSearch = true;
      this.requestEmojipediaList();
    },
    requestEmojipediaList() {
      this.axios
        .post(
          "/overlays/getEmoji",
          {
            search: this.searchValue,
            start: this.emojipediaCurrentSearchStart,
            limit: 25,
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (this.searchValue !== JSON.parse(response.config.data).search) {
            return;
          }
          this.emojipediaLimitSearchCount = response.data.limit;
          this.emojipediaCurrentSearchStart =
            this.emojipediaCurrentSearchStart >= this.emojipediaLimitSearchCount
              ? this.emojipediaLimitSearchCount
              : this.emojipediaCurrentSearchStart + 25;
          response.data.items.forEach((file) => {
            if (!!this.emojipediaFiles.find((f) => f.id === file.id)) {
              return;
            }
            this.emojipediaFiles.push({
              ...file,
              systemMethod: "emoji",
              isPlug: true,
            });
          });
          this.isEmojipediaWaitSearch = false;
        });
    },
    closeWindow(isAddNewState = false) {
      this.selectedFile.file = null;
      this.currentOverlay = null;
      $eventsBus.$emit("muteMainContent", false);
      $eventsBus.$emit("updateAllMoveables");
      if (isAddNewState) {
        this.$store.commit("addNewStateToHistory", true);
      }
      this.$emit("close");
    },
    setTemplateToOverlayText(overlayText, templateId) {
      let currentTemplate = this.textStyleTemplates.find(
        (t) => t.id === templateId
      );
      if (currentTemplate) {
        overlayText.style.color = currentTemplate.color;
        overlayText.style.opacity = currentTemplate.opacity;
        overlayText.style.box.color = currentTemplate.box.color;
        overlayText.style.fontWeight = currentTemplate.fontWeight;
        //overlayText.style.fontStyle = currentTemplate.fontStyle;
        overlayText.value = currentTemplate.value;
        //TODO
      }
      if (currentTemplate.isRectangle) {
        overlayText.moveableObject.resizable = true;
        overlayText.moveableObject.scalable = false;
        overlayText.moveableObject.keepRatio = false;
        overlayText.moveabaleStyle.width = currentTemplate.width;
        overlayText.style.box.width = currentTemplate.box.width
          ? currentTemplate.box.width
          : 0;
        overlayText.moveabaleStyle.height =
          30 + 2 * overlayText.style.box.width + "px";
        overlayText.isRectangle = true;
        overlayText.position = "center-top-border";
      }
    },
    saveNewObjects() {
      this.selectedNewOverlays
        .filter((o) => this.conformityTabType[this.tab].includes(o.type))
        .forEach((overlayObject, i) => {
          let newOverlay = null;
          let twinnedId = `t${(~~(Math.random() * 1e8)).toString(16)}`;
          if (overlayObject.type === "text") {
            newOverlay = new MoveableOverlayText(
              this.previewItem.currentVariation.id,
              twinnedId
            );

            this.setTemplateToOverlayText(newOverlay, overlayObject.templateId);
          } else if (overlayObject.type === "shape") {
            newOverlay = new MoveableOverlayShape(
              this.previewItem.currentVariation.id,
              twinnedId
            );
            newOverlay.file = JSON.parse(JSON.stringify(overlayObject.file));
          } else {
            if (overlayObject.type === "image") {
              newOverlay = new MoveableOverlayImage(
                this.previewItem.currentVariation.id,
                twinnedId
              );
            } else if (overlayObject.type === "video") {
              newOverlay = new MoveableOverlayVideo(
                this.previewItem.currentVariation.id,
                twinnedId
              );
            } else if (overlayObject.type === "stock") {
              newOverlay = new MoveableOverlayStockImage(
                this.previewItem.currentVariation.id,
                twinnedId
              );
            } else if (overlayObject.type === "pixabay") {
              newOverlay = new MoveableOverlayStockImage(
                this.previewItem.currentVariation.id,
                twinnedId
              );
            } else if (overlayObject.type === "pixabay-video") {
              newOverlay = new MoveableOverlayStockVideo(
                this.previewItem.currentVariation.id,
                twinnedId
              );
            } else if (overlayObject.type === "emojipedia") {
              newOverlay = new MoveableOverlayEmojipediaImage(
                this.previewItem.currentVariation.id,
                twinnedId
              );
            } else if (overlayObject.type.startsWith("animation")) {
              newOverlay = new MoveableOverlayAnimation(
                this.previewItem.currentVariation.id,
                twinnedId
              );
            }
            newOverlay.file = _.cloneDeep(overlayObject.file);
          }
          newOverlay.isCustomTime = true;
          newOverlay.finishTime = this.previewItem.duration;
          let position = "";
          if (overlayObject.type === "text") {
            switch (i % 5) {
              case 0:
                position = "center-top-border";
                break;
              case 1:
                position = "center-top";
                break;
              case 2:
                position = "center";
                break;
              case 3:
                position = "center-bottom";
                break;
              case 4:
                position = "center-bottom-border";
                break;
              default:
                break;
            }
          } else {
            switch (i % 9) {
              case 0:
                position = "left-top";
                break;
              case 1:
                position = "center-top";
                break;
              case 2:
                position = "right-top";
                break;
              case 3:
                position = "left-center";
                break;
              case 4:
                position = "center";
                break;
              case 5:
                position = "right-center";
                break;
              case 6:
                position = "left-bottom";
                break;
              case 7:
                position = "center-bottom";
                break;
              case 8:
                position = "right-bottom";
                break;
              default:
                break;
            }
          }

          newOverlay.position = position === "" ? "left-top" : position;
          this.previewItem.currentVariation.overlays.unshift(newOverlay);
          $eventsBus.$emit("updateOverlayPosition", newOverlay, true, true);

          if (overlayObject.type === "image") {
            this.checkAndUpdateRecentImageFiles(newOverlay.file);
          }

          this.saveChangesToCheckedItems(newOverlay);
          $eventsBus.$emit(
            "updateAllDurationForAnimation",
            newOverlay,
            this.previewItem.currentVariation.speed
          );

          $eventsBus.$emit("updateAnimation", newOverlay.id);
        });

      this.closeWindow(true);
    },
    checkAndUpdateRecentImageFiles(overlayFile) {
      const foundFileInRecent = this.recentImageFiles.find(
        (recentImageFile) => {
          const recentImageFileCopy = {
            ...recentImageFile,
            isCopy: null,
            isPlug: null,
            main: null,
          };

          const overlayFileCopy = {
            ...overlayFile,
            isCopy: null,
            isPlug: null,
            main: null,
          };

          return _.isEqual(recentImageFileCopy, overlayFileCopy);
        }
      );
      if (foundFileInRecent) {
        this.$store.commit("deleteRecentImage", foundFileInRecent);
      }
      this.$store.commit("unshiftRecentImages", {
        ...overlayFile,
        isCopy: true,
        isPlug: true,
      });
    },
    saveEditedChanges() {
      let newTwinnedId = `t${(~~(Math.random() * 1e8)).toString(16)}`;
      let oldTwinnedId = this.currentOverlay.twinnedId;
      let overlaysToUpdate =
        this.previewItem.currentVariation.overlays.indexOf(
          this.currentOverlay
        ) !== -1
          ? this.previewItem.currentVariation.overlays
          : this.previewItem.currentVariation.overlaysOfBackside;
      if (this.tab === "text") {
        let newText = new MoveableOverlayText(
          this.previewItem.currentVariation.id,
          this.currentOverlay.twinnedId
        );
        newText.isCustomTime = true;
        newText.finishTime = this.previewItem.duration;
        this.setTemplateToOverlayText(newText, this.selectedTextTemplate);
        let index = overlaysToUpdate.indexOf(this.currentOverlay);

        overlaysToUpdate.splice(index, 1, newText);
        this.saveChangesToCheckedItems(
          newText,
          this.currentOverlay.file,
          true,
          oldTwinnedId
        );
        this.closeWindow(true);
        return;
      } else if (
        this.conformityTabType[this.tab].includes("shape") &&
        !this.conformityTabType[this.tab].some((tabItem) => {
          return tabItem.startsWith("animation");
        })
      ) {
        if (
          !this.selectedFile.file ||
          this.selectedFile.file.systemMethod !== "shape"
        ) {
          return;
        }
        if (this.currentOverlay.type !== "shape") {
          let newShape = new MoveableOverlayShape(
            this.previewItem.currentVariation.id,
            this.currentOverlay.twinnedId
          );
          newShape.isCustomTime = true;
          newShape.finishTime = this.previewItem.duration;
          newShape.file = JSON.parse(JSON.stringify(this.selectedFile.file));
          let index = overlaysToUpdate.indexOf(this.currentOverlay);

          overlaysToUpdate.splice(index, 1, newShape);
          this.saveChangesToCheckedItems(
            newShape,
            this.currentOverlay.file,
            true,
            oldTwinnedId
          );
        } else {
          let oldFile = this.currentOverlay.file;
          this.currentOverlay.file = JSON.parse(
            JSON.stringify(this.selectedFile.file)
          );
          this.saveChangesToCheckedItems(
            this.currentOverlay,
            oldFile,
            false,
            oldTwinnedId
          );
        }
        this.closeWindow(true);
        return;
      } else if (
        this.conformityTabType[this.tab].some((tabItem) => {
          return tabItem.startsWith("animation");
        })
      ) {
        if (
          !this.selectedFile.file ||
          !this.selectedFile.file.systemMethod.startsWith("animation")
        ) {
          return;
        }

        const newAnimation = new MoveableOverlayAnimation(
          this.previewItem.currentVariation.id,
          this.currentOverlay.twinnedId
        );
        newAnimation.isCustomTime = true;
        newAnimation.finishTime = this.previewItem.duration;
        newAnimation.file = _.cloneDeep(this.selectedFile.file);
        const index = overlaysToUpdate.indexOf(this.currentOverlay);

        overlaysToUpdate.splice(index, 1, newAnimation);
        this.saveChangesToCheckedItems(
          newAnimation,
          this.currentOverlay.file,
          true,
          oldTwinnedId
        );

        this.closeWindow(true);
        return;
      } else {
        //TODO
        if (
          !this.selectedFile.file ||
          this.selectedFile.file.systemMethod === "shape"
        ) {
          return;
        }
        if (this.currentOverlay.type === this.selectedFile.type) {
          let oldFile = this.currentOverlay.file;
          this.currentOverlay.file = this.selectedFile.file;
          this.updateStickerRotate(this.currentOverlay);

          if (this.selectedFile.type === "image") {
            this.checkAndUpdateRecentImageFiles(this.currentOverlay.file);
          }

          this.saveChangesToCheckedItems(
            this.currentOverlay,
            oldFile,
            false,
            oldTwinnedId
          );
        } else {
          let newOverlay = null;
          if (this.selectedFile.type === "image") {
            newOverlay = new MoveableOverlayImage(
              this.previewItem.currentVariation.id,
              this.currentOverlay.twinnedId
            );
          } else if (this.selectedFile.type === "video") {
            newOverlay = new MoveableOverlayVideo(
              this.previewItem.currentVariation.id,
              this.currentOverlay.twinnedId
            );
          } else if (this.selectedFile.type === "stock" || this.selectedFile.type === "pixabay") {
            newOverlay = new MoveableOverlayStockImage(
              this.previewItem.currentVariation.id,
              this.currentOverlay.twinnedId
            );
          } else if (this.selectedFile.type === "stock-video" || this.selectedFile.type === "pixabay-video") {
            newOverlay = new MoveableOverlayStockVideo(
              this.previewItem.currentVariation.id,
              this.currentOverlay.twinnedId
            );
          } else if (this.selectedFile.type === "emojipedia") {
            newOverlay = new MoveableOverlayEmojipediaImage(
              this.previewItem.currentVariation.id,
              this.currentOverlay.twinnedId
            );
          }
          newOverlay.file = this.selectedFile.file;

          newOverlay.isCustomTime = true;
          newOverlay.finishTime = this.previewItem.duration;
          this.updateStickerRotate(newOverlay);

          let index = overlaysToUpdate.indexOf(this.currentOverlay);

          overlaysToUpdate.splice(index, 1, newOverlay);

          if (this.selectedFile.type === "image") {
            this.checkAndUpdateRecentImageFiles(newOverlay.file);
          }

          this.saveChangesToCheckedItems(
            newOverlay,
            this.currentOverlay.file,
            true,
            oldTwinnedId
          );
        }
        this.closeWindow(true);
        return;
      }
    },
    saveChanges() {
      if (this.isEditMode) {
        this.saveEditedChanges();
      } else {
        this.saveNewObjects();
      }
    },
    saveChangesToCheckedItems(newOvelay, oldFile, isConverting, oldTwinnedId) {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      this.items.forEach((item) => {
        item.variations.forEach((v) => {
          if (
            !v.checked ||
            (!this.currentOverlay && v === this.previewItem.currentVariation)
          ) {
            return;
          }
          if (this.currentOverlay) {
            let sameOverlays = v
              .getAllOverlays()
              .filter(
                (o) =>
                  o.id !== this.currentOverlay.id &&
                  JSON.stringify(o.file) ===
                    JSON.stringify(oldFile) /*TODO need check it */ &&
                  (oldTwinnedId
                    ? o.twinnedId === oldTwinnedId
                    : o.twinnedId === this.currentOverlay.twinnedId)
              );
            if (isConverting) {
              sameOverlays.forEach((o) => {
                let overlaysToUpdate =
                  v.overlays.indexOf(o) !== -1
                    ? v.overlays
                    : v.overlaysOfBackside;
                let index = overlaysToUpdate.indexOf(o);
                let textCopy = newOvelay.copy();
                textCopy.variationId = v.id;
                textCopy.finishTime = v.parentItem.duration;
                overlaysToUpdate.splice(index, 1, textCopy);
              });
            } else {
              sameOverlays.forEach((o) => {
                o.file = newOvelay.file;
                if (o.type === "shape") {
                  o.file = newOvelay.file;
                  o.style = newOvelay.style;
                } else {
                  o.file = newOvelay.file;
                }
                this.updateStickerRotate(o);
              });
            }
          } else {
            let copy = newOvelay.copy();
            copy.variationId = v.id;
            copy.finishTime = v.parentItem.duration;
            v.overlays.unshift(copy);

            $eventsBus.$emit("updateAllDurationForAnimation", copy, v.speed);
            $eventsBus.$emit("updateAnimation", copy.id);
          }
        });
      });
    },
    onAddNewFile() {
      (<HTMLElement>this.$refs.fileInput).click();
    },
    isFileSelected(file) {
      return this.isEditMode
        ? JSON.stringify(this.selectedFile.file) ===
            JSON.stringify(file) /*TODO need check it */
        : this.selectedNewOverlays.find((o) => {
            return (
              this.conformityTabType[this.tab].includes(o.type) &&
              o.file &&
              _.isEqual(o.file, file)
            ); /*TODO need check it */
          }) !== undefined;
    },
    isTextTemplateSelected(templateId) {
      return this.isEditMode
        ? this.selectedTextTemplate === templateId
        : this.selectedNewOverlays.find(
            (o) => o.type === this.tab && o.templateId === templateId
          ) !== undefined;
    },
    onDeleteFile(file) {
      if (file.main) {
        return;
      }
      let isDelete = window.confirm("Are you sure to delete file?");
      if (!isDelete) {
        return;
      }
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };
      let route = "/overlays/remItem";
      this.axios
        .post(
          route,
          {
            id: file.id,
            sessionId: this.$store.state.userInfo.sessionId,
            systemMethod: file.systemMethod,
          },
          config
        )
        .then((res) => {
          let overlaysToDelete = this.previewItem.currentVariation
            .getAllOverlays()
            .filter((s) => s.file?.id === file.id);
          if (overlaysToDelete.includes(this.currentOverlay)) {
            this.currentOverlay = null;
          }
          overlaysToDelete.forEach((o) => {
            let overlaysToUpdate =
              this.previewItem.currentVariation.overlays.indexOf(o) !== -1
                ? this.previewItem.currentVariation.overlays
                : this.previewItem.currentVariation.overlaysOfBackside;
            overlaysToUpdate.splice(overlaysToUpdate.indexOf(o), 1);
          });
          if (file.type === "image") {
            this.$store.commit("deleteImageFromOverlaysLibrary", file);
            this.recentImageFiles.forEach((recentImageFile) => {
              const recentImageFileCopy = {
                ...recentImageFile,
                isCopy: null,
                isPlug: null,
                main: null,
              };

              const overlayFileCopy = {
                ...file,
                isCopy: null,
                isPlug: null,
                main: null,
              };

              if (_.isEqual(recentImageFileCopy, overlayFileCopy)) {
                this.$store.commit("deleteRecentImage", recentImageFile);
              }
            });
          } else {
            this.$store.commit("deleteVideoFromOverlaysLibrary", file);
          }
          this.searchInLibrary();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    indexOfObjectInSelectedNewOverlays(overlayObject) {
      let overlayObjectInArray = this.selectedNewOverlays.find(
        (o) =>
          o.type === overlayObject.type &&
          ((o.file && overlayObject.file && o.file === overlayObject.file) ||
            (o.templateId !== undefined &&
              overlayObject.templateId !== undefined &&
              o.templateId === overlayObject.templateId))
      );
      return overlayObjectInArray
        ? this.selectedNewOverlays.indexOf(overlayObjectInArray)
        : -1;
    },
    onClickOverlay(event, type, file, textTemplateId?) {
      if (
        textTemplateId === undefined &&
        file.hasOwnProperty("isPlug") &&
        file.isPlug
      ) {
        return;
      }
      if (!this.userStockAccess && type === "stock") {
        return;
      }
      let ctrlKeyPressed = event.ctrlKey || event.metaKey;
      if (!this.isEditMode) {
        let overlayObject = null;
        switch (type) {
          case "image":
          case "video":
          case "animation-shape":
          case "animation-timer":
          case "animation-button":
          case "animation-age-rating":
          case "stock":
          case "pixabay":
          case "pixabay-video":
          case "emojipedia":
            overlayObject = {
              type: type,
              file: file,
            };

            break;
          case "text":
            overlayObject = {
              type: type,
              templateId: textTemplateId,
            };
            break;
          default:
            break;
        }
        let indexOfItem =
          this.indexOfObjectInSelectedNewOverlays(overlayObject);
        if (ctrlKeyPressed) {
          if (indexOfItem === -1) {
            this.selectedNewOverlays.push(overlayObject);
          } else {
            this.selectedNewOverlays.splice(indexOfItem, 1);
          }
        } else {
          this.selectedNewOverlays = [];
          this.selectedNewOverlays.push(overlayObject);
        }
      } else {
        if (type !== "text") {
          this.selectedFile.file = file;
          this.selectedFile.type = type;
        } else {
          this.selectedTextTemplate = textTemplateId;
        }
      }
    },
    isCanSave() {
      if (this.isEditMode) {
        return (
          this.tab === "text" ||
          (this.selectedFile.file &&
            this.conformityTabType[this.tab].includes(this.selectedFile.type))
        );
      } else {
        return (
          this.selectedNewOverlays.filter((o) =>
            this.conformityTabType[this.tab].includes(o.type)
          ).length !== 0
        );
      }
    },
    updateStickerRotate(overlay) {
      /*       if (
        overlay &&
        overlay.file &&
        (overlay.file.type === "video" || overlay.file.type === "gif")
      ) {
        if (overlay.transforms.rotate !== 0) {
          $eventsBus.$emit(
            "setStickerRotate",
            overlay.id,
            -1 * overlay.transforms.rotate
          );
        }
        overlay.moveableObject.rotatable = false;
      } else {
        overlay.moveableObject.rotatable = true;
      } */
    },
    onFileChanged(event: any) {
      let files: FileList = event.target.files;
      this.validateAndUploadFiles(files);
      event.target.value = "";
    },
    validateAndUploadFiles(files) {
      let result: File[] = [];
      const maxCount = 10;
      let maxIndex = files.length > maxCount ? maxCount : files.length;
      for (var i = 0; i < maxIndex; i++) {
        result.push(<File>files.item(i));
      }
      this.uploadFiles(result);
    },
    uploadFiles(files: File[]) {
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };
      const route = "/overlays/itemsUpload";

      files.forEach((item) => {
        let plug = null;
        if (item.type.includes("video") || item.type.includes("gif")) {
          plug = {
            type: "video",
            isPlug: true,
            id: `temp${(~~(Math.random() * 1e8)).toString(16)}`,
          };
          this.$store.commit("unshiftVideoToOverlaysLibrary", plug);
        } else if (item.type.includes("image")) {
          plug = {
            type: "image",
            isPlug: true,
            id: `temp${(~~(Math.random() * 1e8)).toString(16)}`,
          };
          this.$store.commit("unshiftImageToOverlaysLibrary", plug);
        }
        this.searchInLibrary();
        const data = new FormData();
        data.append("files[0]", item);
        data.append("sessionId", this.$store.state.userInfo.sessionId);

        this.axios
          .post(route, data, config)
          .then((res) => {
            const file = res.data[0];
            if (file.type === "video" || file.type === "gif") {
              this.$store.commit("unshiftVideoToOverlaysLibrary", {
                ...file,
                isPlug: true,
              });
            } else {
              this.$store.commit("unshiftImageToOverlaysLibrary", {
                ...file,
                isPlug: true,
              });
            }
            this.searchInLibrary();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.$store.commit("deleteVideoFromOverlaysLibrary", plug);
            this.$store.commit("deleteImageFromOverlaysLibrary", plug);
          });
      });
    },
    checkLoad(file) {
      if (!file) {
        return null;
      }
      let searchedElement = null;

      if (file.systemMethod === "stock") {
        searchedElement = this.stockRoasUpFiles.find((item) => item === file);
      } else if (file.systemMethod === "pixabay") {
        searchedElement = this.stockPixabayFiles.find((item) => item === file);
      } else if (file.systemMethod === "pixabay-video") {
        searchedElement = this.stockPixabayVideoFiles.find(
          (item) => item === file
        );
      } else if (file.systemMethod === "emoji") {
        searchedElement = this.emojipediaFiles.find((item) => item === file);
      } else if (file.type === "image" && !file?.isCopy) {
        this.$store.commit("updateImageInOverlaysLibrary", {
          file: file,
          prop: { isPlug: false },
        });
      } else if (file.type === "image") {
        this.$store.commit("updateRecentImages", {
          file: { ...file, isCopy: true },
          prop: { isPlug: false },
        });
      } else if (file.type === "video" || file.type === "gif") {
        this.$store.commit("updateVideoInOverlaysLibrary", {
          file: file,
          prop: { isPlug: false },
        });
      }

      if (!!searchedElement) {
        searchedElement.isPlug = false;
      }
    },
  },
});
